export interface ConformTextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export function conformTextAreaPropsToAria(
  textAreaProps?: ConformTextAreaProps
) {
  if (!textAreaProps) {
    return {}; // Destructuring happens upstream so we pass an empty object
  }

  return {
    id: textAreaProps.id,
    name: textAreaProps.name,
    maxLength: textAreaProps.maxLength,
    minLength: textAreaProps.minLength,
  };
}
